import React from "react";
import Navbar from "../../components/navbar/Navbar";
import styles from "./TermsOfUse.module.css";

const TermOfUse = () => {
  return (
    <>
      <Navbar showLinks={true} />
      <div className={styles.pagesContainer}>
        <div className={styles.guidelinesCell}>
          <h2>Terms Of Use</h2>
          <p>
            These Terms of Use (the “Terms”), which incorporate our Privacy
            Policy, govern your access to and use of our services, including our
            various websites, such as Rate My O.com, applications, ads,
            communications, events, and other covered products or services that
            link to these Terms (collectively “services”). By accessing and
            using the services, you agree to comply with these Terms. If you’re
            using the services on behalf of a company or other legal entity,
            then “you” also means such company or legal entity and you agree to
            be bound by these Terms even if we have a separate agreement with
            you. You may not use the services if you do not agree to the linked
            version of the Terms at the time you access the services.
            <br />
            For the purposes of these Terms, “Rate My O,” means Rate My O, Inc.
            <br />
            <br />
            <b>
              THESE TERMS REQUIRE THE USE OF ARBITRATION ON AN INDIVIDUAL BASIS
              TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS OR CLASS ACTIONS, AND
              ALSO LIMIT THE REMEDIES AVAILABLE TO YOU IN THE EVENT OF A
              DISPUTE. SEE SECTION 12 FOR ADDITIONAL INFORMATION.
            </b>
            <br />
            <br />
          </p>
          <ol>
            <li>
              <h3>Eligibility to Use the Services</h3>
              <p>
                To access or use the services, you must be at least 18 years of
                age or the age of majority in your jurisdiction, if older, and
                not prohibited from doing so by applicable law. Except as set
                forth below, or as otherwise approved by us, the services are
                for your personal, non-commercial use unless you enter into a
                separate agreement with us for your commercial use. You may not
                use the services if we’ve terminated your account(s) or banned
                you.
              </p>
            </li>
            <li>
              <h3>Rate My O Services Accounts</h3>
              <h4>2.1 Accounts And Profiles</h4>
              <p>
                You agree that the information you provide to us via your
                account(s) is accurate and that you will keep it accurate and
                up-to-date at all times.
                <br />
                <br />
                You’re responsible for safeguarding your account(s), and you
                accept responsibility for all activities that occur via your
                account(s).
                <br />
                <br />
                Rate My O disclaims any liability for third-party actions made
                via your account(s). You agree to notify us immediately if you
                suspect any unauthorized use of your account(s) or access to
                your password(s).
                <br />
                <br />
                We may attempt to verify your employment history or status
                through various methods, including third-party integrations or
                services.
                <br />
                <br />
                We may also in certain circumstances allow you to share your
                Profile with third parties or provide you with the ability to
                change your Profile’s visibility settings.
                <br />
                <br />
                However, your Profile will not publicly include or link to Your
                Content (as defined in section 3), which you submit
                semi-/anonymously to our services.
                <br />
                <br />
                You can read more about your anonymity options in section 4 of
                these Terms and in our Privacy Policy.
                <br />
                <br />
              </p>
              <h4>2.2 Communications</h4>
              <p>
                By creating an account, you agree to accept and receive
                communications from Rate My O, Rate My O affiliates, and our
                third-party service providers.
                <br />
                <br />
                For the purposes of these Terms, “affiliates” means any entity
                that directly or indirectly controls, is controlled by, or is
                under common control of or with Rate My O, now or in the future.
                “Control” means having a majority of shares or the right and
                ability to direct management.
                <br />
                <br />
                These communications may be via email, text messages, push
                notifications, or otherwise.
                <br />
                <br />
                You understand and agree that you may receive communications
                generated by an automatic telephone dialling system delivering
                pre-recorded messages sent by or on behalf of Rate My O, its
                affiliates, and/or our third-party service providers, including
                communications concerning your account(s), our services, and
                services offered by our affiliates. Message and data rates may
                apply.
                <br />
                <br />
                To opt out of receiving text messages, you must reply “STOP”
                from the device receiving the messages.
                <br />
                <br />
                To unsubscribe from non-service-related emails, please use the
                unsubscribe or email settings link in the email(s) you receive.
                If you unsubscribe only from an individual type of email
                communication (e.g., a particular job alert), you will continue
                to receive other types of emails.
                <br />
                <br />
                We may also offer a settings function via our services to manage
                your email preferences.
                <br />
                <br />
                Unless you choose to delete your account(s), you cannot
                unsubscribe from certain communications that are required as
                part of your use of our services (e.g., communications about
                changes to these Terms.)
              </p>
            </li>
            <li>
              <h3>Content on Rate My O Services</h3>
              <p>
                “Content” means any work of authorship or information, including
                photos, logos, advertisements, comments, opinions, postings,
                resumes, salaries, messages, questions, text, files, images,
                works of authorship, e-mail, data, audio, video, or other
                materials.
                <br />
                <br />
              </p>
              <h4>3.1 Rights to Your Content</h4>
              <p>
                You are solely responsible for your use of the services and any
                Content you authorize for use on the services, or which is
                submitted via your account (“Your Content”).
                <br />
                <br />
                We do not claim ownership in Your Content that you submit or
                authorize for use to the services, but you grant us the rights
                to use Your Content as set forth below.
                <br />
                <br />
                By submitting or authorizing us to display Your Content, you
                hereby grant to us a worldwide, unrestricted, irrevocable,
                perpetual, non-exclusive, fully-paid, and royalty-free license
                (with the right to sublicense through unlimited levels of
                sublicenses) to use, reproduce, copy, process, modify, publish,
                translate, transmit, perform, display, create derivative works
                of, adapt, and distribute Your Content in any and all media (now
                known or later developed) throughout the world and display your
                name, images, likeness, voice, video, and any such other Content
                that you submit, link, or otherwise make available through the
                services, throughout the world in any manner or media, on or off
                the services including for purposes of promoting our services.
                <br />
                <br />
                To the greatest extent permitted by applicable law, you hereby
                expressly waive any and all of your moral rights applicable to
                Rate My O’s exercise of this license.
                <br />
                <br />
                You agree that this license includes the right for us to
                provide, promote, and improve the services and to make Content
                submitted to or through the services available to other
                companies, organizations, or individuals for the syndication,
                broadcast, distribution, promotion, or publication of such
                Content on other media and services, subject to our terms and
                conditions for such Content use.
                <br />
                <br />
                Some of the live audio/video events hosted on or through the
                services may be recorded. By using the services and
                attending/participating in such audio/video events you agree to
                any such recordings and agree that all rights, titles, and
                interests in such recordings will vest in Rate My O.
                <br />
                <br />
                You should only submit Content to the services that you are
                comfortable sharing with others under these Terms.
                <br />
                <br />
                By submitting ideas, suggestions, documents, feedback, and/or
                proposals, (collectively, “Submissions”) to Rate My O or its
                employees or agents, you acknowledge and agree that Rate My O is
                entitled to use, disclose, reproduce, license and otherwise
                distribute, and exploit these Submissions as we see fit,
                entirely without obligation or restriction of any kind on
                account of intellectual property rights or otherwise.
                <br />
                <br />
              </p>
              <h4>3.2 Your Limited Rights to Content</h4>
              <p>
                The services contain Content provided by us and our licensors.
                We and our licensors (including other users) own and retain all
                proprietary and intellectual property rights in the Content we
                each provide and Rate My O owns and retains all rights in the
                services. If you’re an authorized user, we hereby grant you a
                limited, revocable, non-transferable, non-sublicensable license
                under the rights licensable by us to use the services and use
                Content from our services solely for your personal use in
                connection with the services. Except as provided in this
                section, you agree not to:
                <br />
                <br />
                reproduce, modify, publish, transmit, distribute, publicly
                perform or display, sell, adapt, or create derivative works
                based on the services or the Content (excluding Your Content);
                or rent, lease, loan, or sell access to the services.
                <br />
                <br />
                The trademarks, logos, and service marks (“Marks”) displayed on
                the services are our property or the property of third parties.
                You are not permitted to use these Marks without our prior
                written consent or the consent of the third party that owns the
                Mark. Rate My O reserves all rights not expressly granted in
                these Terms.
                <br />
                <br />
              </p>
              <h4>3.3 Content on the Services</h4>
              <p>
                Content from Rate My O, as well as users, advertisers, and other
                third parties is made available to you through the services.
                <br />
                <br />
                You understand and agree that:
                <br />
                <br />
                The services may contain or link to sponsored third-party
                Content or ads. The type, degree, and targeting of ads are
                subject to change, and you acknowledge and agree that we may
                place ads in connection with the display of any Content or
                information on the services, including Your Content.
                <br />
                <br />
                We are not responsible for, and do not endorse, any third-party
                Content, including linked content, ads and information about
                third-party products and services, job ads, the employer and
                salary-related information provided by others, or the opinions
                of any third party, including panelists, group leaders, or other
                users, including those involved in audio or video events, or
                translations, transcriptions, or captions of any Content;
                <br />
                <br />
                We make no guarantees about the accuracy, currency, suitability,
                reliability, or quality of the information or Content on or
                linked to via our services, including translations,
                transcriptions, or captions; and
                <br />
                <br />
                We assume no responsibility for unintended, objectionable,
                inaccurate, misleading, or unlawful Content made available by
                users, advertisers, and third parties.
                <br />
                <br />
                In accordance with Section 230 of the U.S. Communications
                Decency Act, and any equivalent or similar laws in other
                jurisdictions which are intended to exclude or limit the
                liability of online service providers who provide access to
                user-generated content, we generally cannot be held liable for
                claims arising from the Content provided by third parties on the
                services. For more information, please see our Legal FAQs.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>Your Use of the Services</h3>
              <h4>4.1 Using Rate My O Services</h4>
              <p>
                Rate My O offers a variety of services that may change from time
                to time, at our sole discretion.
                <br />
                <br />
                Whether or not you’ve set up an account on our services, if you
                use our services we may process your personal data. We describe
                how we may use your personal data in our Privacy Policy.
                <br />
                <br />
                This includes personal data we use to offer or provide our
                services to you, our customers, other users, and the public, as
                well as to manage and improve our services.
                <br />
                <br />
                We also collect and share personal data with third-party service
                providers acting on our behalf, including providers of analytics
                services that may record or log your activities on our services,
                including text you enter, pages you visit, and features you
                interact with.
                <br />
                <br />
                By using our services, you agree to this data processing and
                sharing.
                <br />
                <br />
                We may provide you with the ability to research jobs, including
                via search functionality and through personalized ads and
                recommendations. We may also allow you to submit job
                applications via our services. We work with our affiliates to
                provide this service.
                <br />
                <br /> When you click the apply (or a similar) button to submit
                an application, your application is sent to the most appropriate
                contact information we and/or our affiliates have on file for
                that employer.
                <br />
                <br />
                While we and our affiliates endeavor to make this service the
                best it can be, employer websites and their service providers
                are not controlled by us, and we cannot guarantee that your
                application will be properly received and logged by any
                third-party employer upon transmission. If you have any reason
                to think your application was not received by an employer, we
                suggest you contact them directly to confirm.
                <br />
                <br />
                Rate My O does not guarantee the identity of an employer or any
                individuals working for any employers, and therefore advises
                users to exercise caution when applying to jobs. Rate My O does
                not guarantee the validity of a job offer; users should verify
                the validity of a job offer before taking adverse action
                regarding their current employment situations. You are solely
                responsible for verifying the accuracy of any employer or job
                offer.
                <br />
                <br />
              </p>
              <h4>4.2 Anonymity And Identity On Rate My O</h4>
              <p>
                Depending on the services you use, we may offer you different
                options for controlling how your personal data and identity are
                represented to other users, employers, and the public.
                <br />
                <br />A portion of your Profile on our community and
                conversation services is always public. Therefore, your profile
                picture, company name, title, and other general information (but
                not including your semi-/anonymous Content submissions) will be
                visible to the public and available via search.. Content
                submitted with semi-/anonymous identifiers such as your company
                name or job title is not associated with the publicly-visible
                portion of your Profile.
                <br />
                <br />
                When you submit Content such as a post, comment, or question,
                you may be able to control how you represent yourself using
                different anonymity options. For example, when using some of our
                services, you can choose to submit Content with your company
                name, your job title, or your full name.
                <br />
                <br />
                When submitting other Content, such as reviews, you may be
                required to include certain personal data for public display,
                such as your employer, job title, and/or location. In some
                groups, we may allow you to make your Profile visible to other
                members of the group so you can interact with them. <br />
                <br />
                In some instances, we may allow group leaders to limit access to
                a group and approve new group members. When you request access
                to a group, your Profile and answers to member-approval
                questions may be shared with the leader(s) for that group.
                <br />
                <br />
                We endeavor to offer opportunities to use our services while
                preserving your anonymity, However, you acknowledge that Rate My
                O cannot guarantee your anonymity as, depending on your specific
                situation and circumstances and the contents of your Content,
                even semi-/anonymous identifiers, such as company or job title,
                especially when paired with other information such as your
                location, may allow someone to identify you or narrow down your
                identity to a small group of people (e.g., employees in a
                particular department at your company). You should understand
                this risk before submitting Content to the services.
                <br />
                <br />
              </p>
              <h4>4.3 House Rules</h4>
              <p>
                You represent and warrant that you will use the services solely
                for lawful purposes in a manner consistent with these Terms and
                any and all applicable laws, regulations, or other legally
                enforceable obligations (including contractual obligations) you
                may have towards us and/or any third parties.
                <br />
                <br />
                You are solely responsible for your use of the services and Your
                Content.
                <br />
                <br />
                You agree that by submitting or authorizing Your Content for use
                on the services, you have reviewed,understood, and agreed to our
                Terms.
                <br />
                <br />
                You understand that you may expose yourself to liability if Your
                Content or use of the services violates applicable law or any
                third-party right.
                <br />
                <br />
                If you choose to use the services to conduct a promotion,
                including a contest or sweepstakes (“Promotion”), you alone are
                responsible for conducting the Promotion in compliance with all
                applicable laws and regulations.
                <br />
                <br />
                You and your Promotion must state that the Promotion is not
                sponsored by, endorsed by, or associated with Rate My O or our
                services. You acknowledge and agree that we will not assist you
                in any way with your Promotion, and you agree to conduct your
                Promotion at your own risk.
                <br />
                <br />
                We reserve the right to restrict your use of the services to
                conduct Promotions. We allow users to submit Content about their
                experiences working for employers when they have been employed
                by the employer as a full-time, part-time, contractor,
                freelancer, independent employee, or provide work that is an
                integral part of the employer’s value chain.
                <br />
                <br />
                We also allow users to submit Content regarding the staffing
                firms that place them in these roles.
                <br />
                <br />
                We consider all workers in these roles as ’employees’ with
                regard to Content submitted to Rate My O services.
                <br />
                <br />
                While we may provide the option for Rate My O users to specify
                the category of their employment when they submit Content (e.g
                contractor, freelancer), we may not consider this a requirement.
                It does not violate our Community Guidelines or these Terms for
                a worker in any one of these roles to submit Content as an
                “employee.”
                <br />
                <br />
                You agree that you will not:
                <br />
                <br />
                Impersonate another person, or use their email address or phone
                number, or misrepresent your current or former affiliation with
                an employer;
                <br />
                <br />
                Create accounts under false or fraudulent pretenses; create or
                use an account for anyone other than yourself; or create
                multiple active accounts to submit Content or interact with
                other users;
                <br />
                <br />
                Submit Content that you do not own or have the right to submit
                in accordance with the license set forth in these Terms;
                <br />
                <br />
                Violate these Terms, the terms of your agreements with us,
                explicit restrictions set forth in our Community Guidelines, or
                any applicable law, rule, or regulation;
                <br />
                <br />
                Submit Content that is defamatory, libelous, or fraudulent; that
                you know to be false or misleading; or that does not reflect
                your honest opinion and authentic experience;
                <br />
                <br />
                Act in a manner that is harassing, trolling, threatening,
                abusive, racist, bigoted, or is otherwise objectionable (as
                solely determined by Rate My O);
                <br />
                <br />
                Promote, endorse, or further illegal activities;
                <br />
                <br />
                Disclose information in violation of any legally enforceable
                confidentiality, non-disclosure, or other contractual
                restrictions or rights of any third party, including any current
                or former employers or potential employers;
                <br />
                <br />
                Violate the privacy, publicity, copyright, patent, trademark,
                trade secret, or other intellectual property or proprietary
                rights of any third-party;
                <br />
                <br />
                Submit anything pornographic or sexually explicit in nature, or
                engage in the exploitation of persons in a sexual or violent
                manner;
                <br />
                <br />
                Solicit or submit minors’ personal data; Except as expressly
                approved by us or as otherwise approved in these Terms, and
                subject to applicable laws, use the services for commercial
                activities and/or promotions such as contests, sweepstakes,
                barter, pyramid schemes, advertising, affiliate links, and other
                forms of solicitation;
                <br />
                <br />
                Imply a Rate My O endorsement, sponsorship, or partnership of
                any kind without our express written permission;
                <br />
                <br />
                Send messages in violation of the USA CAN-SPAM Act or any other
                applicable anti-spam law;
                <br />
                <br />
                Introduce software or automated agents to the services, or
                access the services so as to produce multiple accounts, generate
                automated messages, or to scrape, strip, or mine data from the
                services without our express written permission;
                <br />
                <br />
                “Frame” or “mirror” or otherwise incorporate part of the
                services into any website, or “deep-link” to any portion of the
                services without our express written permission (except in
                instances where we make such functionality available via an API
                or formal embedding feature);
                <br />
                <br />
                Copy, modify, or create derivative works of the services or any
                Content (excluding Your Content) without our express written
                permission;
                <br />
                <br />
                Copy or use the information, Content (excluding Your Content),
                or data on the services in connection with a competitive
                service, as solely determined by Rate My O;
                <br />
                <br />
                Violate antitrust laws by engaging in anticompetitive conduct,
                such as sharing commercially sensitive information pursuant to
                an express or tacit agreement in restraint of trade;
                <br />
                <br />
                Sell, resell, rent, lease, loan, trade, or otherwise monetize
                access to the services or any Content (excluding Your Content)
                without our express written permission;
                <br />
                <br />
                Interfere with, disrupt, modify, reverse engineer, or decompile
                any data or functionality of the services;
                <br />
                <br />
                Interfere with, disrupt, or create an undue burden on the
                services or the networks or services connected to the services;
                and/or
                <br />
                <br />
                Introduce any viruses, trojan horses, worms, time bombs,
                cancelbots, corrupted files, or similar software to the
                services; or attempt to circumvent any security feature of the
                services.
                <br />
                <br />
              </p>
              <h4>4.3 Actions We May Take</h4>
              <p>
                We may, at our sole discretion:
                <br />
                <br />
                Stop (permanently or temporarily) providing the services or any
                features within the services to you or to users generally.
                <br />
                <br />
                Create limits on use and storage at our sole discretion at any
                time.
                <br />
                <br />
                Remove, refuse to distribute, or limit distribution or
                visibility of any Content on the services.
                <br />
                <br />
                Suspend or terminate users.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>
                Special Provisions Applicable to Employers and Enterprise
                Customers.
              </h3>
              <h4>5.1 Posting Jobs to the Services </h4>
              <p>
                You may not post any job ad, as determined solely by Rate My O,
                that:
                <br />
                <br />
                Does not comply with the applicable laws or regulations of the
                state and country where the job is to be performed, including
                laws relating to labor and employment, equal employment
                opportunity and employment eligibility requirements, data
                privacy, data access and use, and intellectual property;
                <br />
                <br />
                Contains false information or solicits employees by intentional
                misrepresentation, such as, misrepresentation of the terms of
                employment, the hiring entity, or the identity of the poster;
                <br />
                <br />
                Requires an application fee or up-front or periodic payments;
                requires recruitments of others; resembles a multi-level
                marketing scheme, franchise, pyramid scheme, “club membership”,
                distributorship or sales representative agency arrangement; only
                pays commissions (except where the listing makes clear that the
                available job pays commission only and clearly describes the
                product or service that the job seeker/user would be selling);
                or resembles a multi-level marketing scheme;
                <br />
                <br />
                Involves any screening requirement where such screening
                requirement is not an actual and legal requirement of the
                advertised position;
                <br />
                <br />
                Contains any logo or brands, or link to websites, other than
                your own or those of any entity for which you are authorized to
                submit job ads;
                <br />
                <br />
                Contains multiple job openings in a single job ad (unless you’ve
                purchased a service that permits this);
                <br />
                <br />
                Does not comply with Title VII of the Civil Rights Act or the
                EEOC’s Enforcement Guidance on Employer’s Consideration of
                Arrest and Conviction Records in Employment Decisions, and/or
                relevant national, federal, state, and local laws that prohibit
                employers from discriminating against people with criminal
                backgrounds and require employers to delay inquiry into an
                applicant’s criminal history until later in the hiring process;
                <br />
                <br />
                Discriminates against applicants on the basis of gender, race,
                religion, sexual orientation, age, disability, or any other
                ground(s) prohibited by applicable law.
                <br />
                <br />
                You agree that Rate My O may, at its sole discretion, remove or
                prevent the posting of any job ad for any or no reason.
                <br />
                <br />
              </p>
              <h4>5.2 Content on Rate My O Services </h4>
              <p>
                You may not offer incentives in exchange for Content related to
                any company. You may not trade Content submissions with other
                employers. We will remove Content where we believe that users
                were compensated to submit Content.
                <br />
                <br />
                You may not coerce employees to submit Content. Coercion
                includes asking employees to provide proof to an employer that
                they submitted Content whether or not that proof includes the
                contents of the Content itself..
                <br />
                <br />
              </p>
              <h4>5.3 Communications With Users </h4>
              <p>
                We may inform a user when you have taken an action with respect
                to information we or our affiliates have shared with you on
                behalf of that user, such as when you open the user’s
                application, view their resume or profile on the services (or an
                affiliate’s services), and/or make a decision about their
                application.
                <br />
                <br />
                When you view, store, or receive materials through your use of
                the services or an affiliate’s services, we may use such
                materials for data analysis, quality control, or to refine our
                services and services.
                <br />
                <br />
                We may also share with our users our observations based on such
                data analysis. For example, we may tell our users which
                employers are more likely to open applications submitted via the
                services, which employers are active on the services, and how
                long on average certain aspects of the candidate process take
                for a given employer.
                <br />
                <br />
                We may send out reminder emails to users you wish to interview.
                <br />
                <br />
                We may also send emails to users on your behalf indicating that
                your job ad is potentially a match for the user’s resume or job
                preferences. You understand and agree that Rate My O may take
                such actions.
                <br />
                <br />
              </p>
              <h4>5.4 Special Provisions Applicable to Advertisers </h4>
              <p>
                This provision applies to all advertisers, including employers
                who purchase or post job ads or display ads. Unless we agree
                otherwise, you may not use or otherwise process data collected
                or derived from ads (“Ad Data”) for any purpose (including
                retargeting, building or augmenting user profiles, allowing
                piggybacking or redirecting with tags, or combining with data
                across multiple advertisers’ campaigns) other than to assess the
                performance and effectiveness of your campaigns on an aggregate
                and anonymous basis.
                <br />
                <br />
                You may not, and you may not permit a third party to, transfer
                or sell any Ad Data to, or use Ad Data in connection with, any
                ad network, ad exchange, data broker, or other party not acting
                on behalf of you and your campaigns.
                <br />
                <br />
                You may use information provided directly to you from users if
                you provide clear notice to and obtain applicable consent from
                those users and comply with all applicable laws and industry
                guidelines, including those applicable to data protection.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>Enforcement by Rate My O or Third Parties</h3>
              <h4>6.1 Removal of Content </h4>
              <p>
                While we have no obligation to do so, we reserve the right to
                review and remove any Content (or portion thereof) that we
                believe, in our sole discretion, violates these Terms or other
                applicable policies linked on the services (including our
                Community Guidelines), or that we deem, in our sole discretion,
                inappropriate.
                <br />
                <br /> If you see any Content on the services that you believe
                violates our policies, you may report that Content by clicking
                on an applicable report link adjacent to that Content or by
                contacting us.
                <br />
                <br />
                Once notified, we will review the Content and consider whether
                to remove it (or a portion thereof). Please note: our
                interpretation of our policies and the decision whether or not
                to remove Content is within our sole discretion.
                <br />
                <br /> You understand and agree that if we choose not to remove
                or edit Content that you find objectionable, that decision will
                not constitute a violation of these Terms or any agreement we
                have with you.
                <br />
                <br />
              </p>
              <h4>6.2 Copyright Policy </h4>
              <p>
                Please see our Copyright Complaint Policy for information about
                copyright disputes.
                <br />
                <br />
              </p>
              <h4>6.3 Other Enforcement Actions </h4>
              <p>
                While we have no obligation to do so, we reserve the right to
                investigate and take appropriate action in our sole discretion
                against you if you violate these Terms, including without
                limitation: removing Content (or portions thereof) from the
                services; suspending some or all of your rights to use the
                services; terminating your account(s); reporting you to law
                enforcement, regulatory authorities, or administrative bodies;
                and taking legal action against you.
              </p>
              <h4>6.4 Disclosing User Personal Data & Defending our Users </h4>
              <p>
                You understand and agree that in certain circumstances we may
                disclose users’ personal data to third parties, such as when we
                are required to by law or valid legal process. You can read more
                about the specific circumstances in the “Other Instances When We
                May Disclose Your Data” section of our Privacy Policy.
                <br />
                <br />
                While we have no obligation to do so, we reserve the right, to
                the fullest extent permitted by applicable law, to take
                appropriate action to protect the anonymity of our users against
                the enforcement of subpoenas or other information requests that
                seek a user’s identifying information or personal data. We make
                no guarantee or representation that we will seek to protect user
                anonymity or, if we elect to do so, that we will be successful.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>Indemnity</h3>
              <p>
                You agree to defend, indemnify, and hold us and our affiliates
                and subsidiaries and our and their respective officers,
                directors, board members, board advisors, employees, partners,
                agents successors and assigns (collectively, the “Rate My O”)
                harmless from any loss, liability, claim, or demand, including
                reasonable attorneys’ fees and costs, made by any third party
                due to or otherwise arising from your use of the services,
                including due to or arising from your breach of any provision of
                these Terms, or related to you providing false information
                regarding your identity or employment history or status.
              </p>
            </li>
            <li>
              <h3>Disclaimers and Limitation on Liability</h3>
              <p>
                The disclaimers and limitations on liability in this section
                apply to the maximum extent allowable under applicable law.
                Nothing in this section is intended to limit any rights you have
                which may not be lawfully limited.
                <br />
                <br />
                Any communications, including emails, texts, or notifications or
                messages corresponding with any activity on the services or any
                other communications service, product, or feature provided on or
                through the services, are provided solely as a courtesy.
                <br />
                <br />
                Rate My O disclaims all warranties with regard to the
                transmission or storage of these courtesy notices, does not
                guarantee their delivery or receipt, and does not guarantee the
                date or time at which they may be sent or received. In the event
                a message being sent is intended for a closed account, these
                messages will not be deliverable.
                <br />
                <br />
                Rate My O assumes no responsibility and disclaims all liability
                for the content, accuracy, completeness, legality, reliability,
                or availability of any information, including job posting/ad,
                salary estimate, template, career page, screener question,
                answer to screener question, resume information, message, or
                Content you submit, send, view, or receive through the services.
                <br />
                <br />
                You are solely responsible for your interactions with
                advertisers, employers, and other users and we are not
                responsible for their activities, omissions, or other conduct,
                whether online or offline. We are not responsible for any
                incorrect, inaccurate, or unlawful Content (including any
                information in Profiles) submitted to the services, whether
                caused by users or by any of the equipment or programming
                associated with or utilized in the services.
                <br />
                <br />
                We assume no responsibility for any error, omission,
                interruption, deletion, defect, delay in operation or
                transmission, communications line failure, theft or destruction
                or unauthorized access to, or alteration of, any communication
                with advertisers, employers, or other users.
                <br />
                <br />
                We are not responsible for any problems or technical malfunction
                of any hardware and software due to technical problems on the
                Internet or on the services or combination thereof, including
                any injury or damage to users or to any person’s device related
                to or resulting from participation or downloading materials in
                connection with the services. Under no circumstances shall we be
                responsible for any loss or damage resulting from the use of the
                services or from any Content submitted to the services or
                transmitted to users, or any interactions between users of the
                services, whether online or offline.
                <br />
                <br />
                THE SERVICES ARE PROVIDED “AS-IS” AND AS AVAILABLE. WE EXPRESSLY
                DISCLAIM ANY WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER
                EXPRESS OR IMPLIED, INCLUDING THE WARRANTIES OR CONDITIONS OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET
                ENJOYMENT, ACCURACY, OR NON-INFRINGEMENT. WE MAKE NO WARRANTY
                THAT: (1) THE SERVICES WILL MEET YOUR REQUIREMENTS; (2) THE
                SERVICES WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE,
                OR ERROR-FREE BASIS; OR (3) THE RESULTS THAT MAY BE OBTAINED
                FROM THE USE OF THE SERVICES WILL BE ACCURATE OR RELIABLE.
                <br />
                <br />
                YOU HEREBY RELEASE THE Rate My O GROUP FROM ANY AND ALL CLAIMS,
                DEMANDS, AND LOSSES, DAMAGES, RIGHTS, CLAIMS, AND ACTIONS OF ANY
                KIND THAT ARE EITHER DIRECTLY OR INDIRECTLY RELATED TO OR ARISES
                FROM: (1) THE ACTIONS, CONTENT, OR DATA OF THIRD PARTIES
                (INCLUDING, ADVERTISERS, EMPLOYERS, AND OTHER USERS) (2) YOUR
                PARTICIPATION IN ANY OFFLINE EVENTS.
                <br />
                <br />
                Rate My O reserves the right in its sole discretion to review,
                improve, modify, or discontinue, temporarily or permanently, the
                services and/or any features, information, services, materials,
                Content, or information on the services with or without notice
                to you. You agree that Rate My O will not be liable to you or
                any third party for any modification or discontinuance of the
                service or any portion thereof. Rate My O reserves the right to
                modify, change or alter terms and conditions and policies and
                will post changes to the website, once posted these terms are
                effective immediately and use of the site will signify agreement
                to be bound by these terms and conditions.
                <br />
                <br />
                IN NO EVENT SHALL THE Rate My O GROUP BE LIABLE TO YOU OR ANY
                THIRD PARTY FOR ANY LOST PROFIT OR ANY INDIRECT, CONSEQUENTIAL,
                EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES ARISING FROM
                YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE
                POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE
                CONTRARY CONTAINED IN THESE TERMS, WHERE PERMITTED BY APPLICABLE
                LAW, YOU AGREE THAT THE Rate My O GROUP’S LIABILITY TO YOU FOR
                ANY DAMAGES ARISING FROM OR RELATED TO YOUR USE OF THE SERVICES
                (FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE
                ACTION), WILL AT ALL TIMES BE LIMITED TO ONE U.S. DOLLARS ($1).
                <br />
                <br />
                You acknowledge that you are familiar with the provisions of
                Section 1542 of the California Civil Code (or similar applicable
                law in your jurisdiction), which provides as follows: “A GENERAL
                RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT
                KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF
                EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE
                MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR.” You
                hereby expressly waive and relinquish all rights and benefits
                under Section 1542 of the California Civil Code and any law or
                legal principle of similar effect in any jurisdiction with
                respect to the releases and/or discharges granted in these
                Terms, including but not limited to the releases and/or
                discharges of unknown claims.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>Termination</h3>
              <p>
                These Terms remain in effect while you use the services and, for
                registered users, as long as your account(s) remains open.
                <br />
                <br />
                You may delete your account(s) at any time. We may suspend or
                terminate your account(s) or your access to parts of the
                services, for any or no reason, without notice to you. We will
                have no liability whatsoever to you for any termination of your
                account(s) or related deletion of your data.
                <br />
                <br />
                All provisions of these Terms shall survive termination or
                expiration of these Terms except those provisions granting
                access to or use of the services. For the avoidance of doubt,
                you agree that these Terms apply to your use of the services and
                any Content submitted on the services at any time prior to the
                termination or expiration of these Terms.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>Changes to These Terms</h3>
              <p>
                We may revise these Terms from time to time by posting an
                updated version available via a link on the services. If we make
                a change that we believe materially reduces your rights or
                increases your responsibilities, we will notify you by
                communication (e.g., by email or text message sent to the e-mail
                address or phone number specified in your account) and/or by
                means of a notice on the services prior to the change becoming
                effective.
                <br />
                <br />
                We may provide notice of changes in other circumstances as well.
                Any such changes will not apply to any claim brought prior to
                the effective date of the revised Terms incorporating such
                changes. We encourage you to periodically review this page for
                the latest information on our Terms. Your continued use of the
                services is subject to the most current effective version of
                these Terms.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>Pre-Suit Discovery & Analogous Procedures Or Applications</h3>
              <p>
                You agree to waive your right to file a pre-suit discovery
                proceeding (or any equivalent procedure in jurisdictions other
                than the U.S.) seeking a user’s identifying information from
                Rate My O. If you intend to propound discovery seeking a user’s
                identifying information, you agree to do so pursuant to a valid
                California subpoena, properly issued in connection with an
                active lawsuit and properly served to us.
                <br />
                <br /> You further agree that all such subpoenas and discovery
                proceedings arising from such subpoenas shall be issued from,
                brought, and resolved exclusively in the state courts located
                within Ventura County, California or the federal courts in the
                Central District of California, as appropriate, and you agree to
                submit to the personal jurisdiction of each of these courts for
                such discovery proceedings.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>Dispute Resolution</h3>
              <p>
                PLEASE READ THIS SECTION 12 CAREFULLY AS IT AFFECTS YOUR RIGHTS.
                UNLESS YOU OPT OUT OF ARBITRATION PURSUANT TO SECTION 12.2.3
                BELOW, YOU AGREE THAT BY ENTERING INTO THESE TERMS, YOU AND Rate
                My O ARE EACH WAIVING THE RIGHT TO TRIAL BY JURY OR TO
                PARTICIPATE IN A CLASS ACTION. YOU AND Rate My O AGREE THAT EACH
                PARTY MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS
                INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN
                ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. ANY
                ARBITRATION WILL TAKE PLACE ON AN INDIVIDUAL BASIS; CLASS
                ARBITRATIONS ARE NOT PERMITTED.
                <br />
                <br />
              </p>
              <h4>12.1 Informal Dispute Resolution </h4>
              <p>
                If either of us intends to seek arbitration under this section,
                the party seeking arbitration must first notify the other party
                of the dispute in writing at least 30 days in advance of
                initiating arbitration. You and we agree that the opportunity to
                meet and confer informally is a material term and a material
                reason we are offering this service and therefore you agree you
                will abide by it. <br />
                <br />
                Notice to Rate My O should be sent to our email:{" "}
                <a href="mailto:main@ratemyo.com">main@ratemyo.com</a> . If you
                have an account with our services, we will provide notice by
                means of communication to the email address or phone number
                associated with your account. <br />
                <br />
                Any notice of dispute (“Notice”) must (1) describe the nature
                and basis of the claim or dispute, and (2) set forth the
                specific relief sought. You may download or copy a form Notice
                here. <br />
                <br />
                During the 30-day period, you and We, agree to act in good faith
                to resolve the dispute. If you and Rate My O cannot reach an
                agreement to resolve the claim within 30 days after the Notice
                is received, you or Rate My O may commence formal proceedings in
                accordance with section 12.2.
                <br />
                <br />
              </p>
              <h4>
                12.2 Binding Arbitration Agreement, Exceptions to Arbitration,
                Governing Law & Venue{" "}
              </h4>

              <p>
                <b>
                  12.2.1 Agreement to Arbitrate and Class Action/Class
                  Arbitration Waiver.
                </b>
                <br />
                <br />
                Subject to the exceptions to arbitration set forth in subpart
                12.2.4 below, you and Rate My O each agree that any and all
                disputes between Rate My O and consumer (i.e.,
                non-business/commercial) users arising under or related in any
                way to these Terms and/or your use of our services (and which
                are not otherwise resolved pursuant to section 12.1) must be
                resolved through binding arbitration as described in section
                12.2. If an arbitrator or court decides that any part of this
                agreement to arbitrate set forth in section 12.2 is
                unenforceable, the remainder of section 12 of these Terms will
                nevertheless still apply (including the prohibition on class
                arbitration).
                <br />
                <br />
                <b>12.2.2 Arbitration Procedure.</b>
                Any arbitration will be governed by the Consumer Arbitration
                Rules of the American Arbitration Association (“AAA”), if
                applicable, as modified by this section. <br />
                <br />
                The AAA’s rules and a form for initiating the proceeding are
                available at www.adr.org. Any settlement offer made by you or
                Rate My O shall not be disclosed to the arbitrator. <br />
                <br />
                Unless otherwise required by the applicable arbitration rules,
                the arbitration shall be held in Oxnard, California. <br />
                <br />
                For any claim where the total amount of the award sought is
                $10,000 or less, you and Rate My O must have the arbitration
                conducted by audio and/or a video communication system
                (including, but not limited to telephone conference or a video
                conference platform such as Zoom) or based solely on written
                submissions, which shall be binding on you and Rate My O subject
                to the arbitrator’s discretion to require an in-person hearing.{" "}
                <br />
                <br />
                In cases where an in-person hearing is held, you or Rate My O
                may attend by audio and/or a video communication system
                (including, but not limited to telephone conference or a video
                conference platform such as Zoom), unless the arbitrator
                requires otherwise. <br />
                <br />
                The arbitrator will decide the substance of all claims in
                accordance with applicable law, including recognized principles
                of equity, and will honor all claims of privilege recognized by
                law. <br />
                <br />
                The arbitrator shall not be bound by rulings in prior
                arbitrations involving different users but is bound by rulings
                in prior arbitrations involving the same user to the extent
                required by applicable law. <br />
                <br />
                The arbitrator’s award shall be final and binding and judgment
                on the award rendered by the arbitrator may be entered in any
                court having jurisdiction thereof. <br />
                <br />
              </p>
              <h4>12.3 Opt-Out Procedure</h4>
              <p>
                IF YOU ARE A NEW USER, YOU CAN CHOOSE TO REJECT THIS AGREEMENT
                TO ARBITRATE (“OPT-OUT”) BY MAILING US A WRITTEN OPT-OUT NOTICE
                (“OPT-OUT NOTICE”). THE OPT-OUT NOTICE MUST BE POSTMARKED NO
                LATER THAN 30 DAYS AFTER THE DATE YOU ACCEPT THESE TERMS FOR THE
                FIRST TIME. YOU MUST MAIL THE OPT-OUT NOTICE TO Rate My O, via
                our email: main@ratemyo.com <br />
                <br />
                For your convenience, we are providing an Opt-Out Notice form
                that you may use. Please make sure to include your name, and the
                email address(es) associated with the account(s) to which the
                opt-out applies. You must sign the Opt-Out Notice for it to be
                effective. <br />
                <br />
                This procedure is the only way you can opt out of the agreement
                to arbitrate set forth in section 12.2. If you opt out of the
                agreement to arbitrate set forth in this section, all other
                parts of these Terms and Section 12 will continue to apply to
                you. <br />
                <br />
                Opting out of the agreement to arbitrate has no effect on any
                previous, other, or future arbitration agreements that you may
                enter into or have entered into with us. <br />
                <br />
              </p>
              <p>
                <b> 12.2.4 Exceptions to Arbitration. </b>
                <br />
                The agreement to arbitration provisions set forth in subparts
                12.2.1 and 12.2.2 above will not apply to the following: <br />
                <br />
              </p>
              <ul>
                <li>
                  small claims court cases that qualify for small claims status;
                </li>
                <li>
                  legal proceedings or procedures that involve efforts to obtain
                  personal data related to a user or users, including but not
                  limited to the author of any Rate My O Content or review;
                </li>
                <li>
                  any legal proceedings brought against any of the Rate My O
                  Group by companies or other legal entities, or individuals
                  acting on behalf of such companies or other legal entities;
                </li>
                <li>
                  any legal proceedings brought by any of the Rate My O Group
                  against companies or other legal entities, or individuals
                  acting on behalf of any such companies or other legal
                  entities; and
                </li>
                <li>
                  a party’s right to seek injunctive or other equitable relief
                  in a court of competent jurisdiction to prevent the actual or
                  threatened infringement, misappropriation or violation of a
                  party’s copyrights, trademarks, trade secrets, patents, or
                  other intellectual property rights.
                </li>
                <li>
                  any claim for public injunctive relief, which must be
                  adjudicated in court, not by the arbitrator. If either party
                  seeks public injunctive relief, that request for relief shall
                  be severed from any arbitration proceeding and stayed pending
                  a final resolution of the arbitration, at which point the
                  claim may be adjudicated.
                </li>
                <li>
                  any claim not already subject to one of the exceptions listed
                  in section 12.2.4 where any or all of the non-Rate My O Group
                  parties are located outside of the United States.
                </li>
              </ul>
              <p>
                If, for some reason, the prohibition on class arbitrations set
                forth in section 12 cannot be enforced, then the entirety of the
                agreement to arbitrate set forth in subparts 12.2.1-3 will not
                apply; the remainder of section 12 will continue to apply <br />
                <br />
              </p>
              <p>
                <b>12.2.5 Governing Law and Venue.</b>
                <br />
                <br />
                For claims subject to the exceptions to arbitration set forth in
                subpart 12.2.4, these Terms and any and all claims, disputes, or
                other legal proceedings by or between you or us, including but
                not limited to any such claims or disputes that are in any way
                related to or arising under these Terms or your access to or use
                of our services, shall be governed by the laws of the State of
                California without giving effect to any conflict-of-laws
                principles that may otherwise provide for the application of the
                law of another jurisdiction.
                <br />
                <br />
                These claims or disputes shall be brought and litigated
                exclusively in the state courts located within Ventura County,
                California or the federal courts in the Central District of
                California, as appropriate, and you agree to submit to the
                personal jurisdiction of each of these courts for the purpose of
                litigating such claims or disputes.
                <br />
                <br />
                For all claims not subject to the exceptions to arbitration set
                forth in subpart 12.2.4, the parties agree that their
                arrangement under these Terms is in interstate commerce and that
                the Federal Arbitration Act applies to the construction of the
                agreement to arbitrate provisions set forth in section 12.2.
                <br />
                <br />
              </p>
              <p>
                <b>12.2.6 Changes To The Agreement To Arbitrate.</b>
                <br />
                <br />
                We will notify you of changes to section 12 by posting the
                changes at least 30 days before the effective date of the
                changes and by notice to the email address associated with your
                account. It is therefore essential that you keep your email
                address up to date. You can update your email address from your
                accounts settings page.
                <br />
                <br />
                If you do not agree to the changed terms, you may close your
                account within the 30-day period and you will not be bound by
                these changes. Otherwise, if you continue to use our services,
                the changed terms will apply to all disputes or claims governed
                by this section 12 that have arisen or may arise between you and
                Rate My O which are initiated after the time the changed terms
                take effect.
                <br />
                <br />
                Notwithstanding any provision in these Terms to the contrary,
                you and we agree that if we make any changes to section 12
                (other than a change to any referenced notice address or site
                links) in the future, that change will not apply to any claim
                that was filed in a legal proceeding before the effective date
                of the change.
                <br />
                <br />
              </p>
            </li>
            <li>
              <h3>Miscellaneous</h3>
              <ul>
                <li>
                  Except as specifically stated in another agreement we have
                  with you, these Terms, and any other agreements, documents, or
                  policies incorporated by reference in these Terms, constitute
                  the entire agreement between you and us regarding the use of
                  the services and these Terms supersede all prior proposals,
                  negotiations, agreements, and understandings concerning the
                  subject matter of these Terms.
                </li>
                <li>
                  You represent and warrant that no person has made any promise,
                  representation, or warranty, whether express or implied, not
                  contained in these Terms to induce you to enter into this
                  agreement.
                </li>
              </ul>
              <p>
                <br />
                Our failure to exercise or enforce any right or provision of
                these Terms shall not operate as a waiver of such right or
                provision.
                <br />
                <br />
                If any provision of the Terms is found to be unenforceable or
                invalid, then only that provision shall be modified to reflect
                the parties’ intention or eliminated to the minimum extent
                necessary so that the Terms shall otherwise remain in full force
                and effect and enforceable.
                <br />
                <br />
                To the extent allowed by law, the English language version of
                these Terms are binding and any translations are provided for
                convenience only.
                <br />
                <br />
                The Terms, and any rights or obligations hereunder, are not
                assignable, transferable or sublicensable by you except with
                Rate My O’s prior written consent, but may be assigned or
                transferred by us without restriction. Any attempted assignment
                by you shall violate these Terms and be void.
                <br />
                <br />
                The section titles in these Terms are for convenience only and
                have no legal or contractual effect. As used in these Terms, the
                word “including” means “including but not limited to.”
                <br />
                <br />
                Please contact us with any questions regarding these Terms.
                <br />
              </p>
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default TermOfUse;
